// extracted by mini-css-extract-plugin
module.exports = {"FinishedQuiz":"FinishedQuiz_FinishedQuiz__2GOTa","error":"FinishedQuiz_error__3vLA6","success":"FinishedQuiz_success__1YG3f"};